import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import InlineAlert from "../ui/InlineAlert";
import { relativeMoment } from "./workspaceOverviewModel";
import "./workspaceOverview.css";

export default function WorkspaceActivity() {
  const [events, setEvents] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    api.get("/workspace/activity").then((response) => {
      if (!cancelled) setEvents(response.data?.events || []);
    }).catch(() => {
      if (!cancelled) setError("Activity could not be loaded.");
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="rr-overview">
      <header className="rr-overview-head">
        <p className="rr-eyebrow">Workspace</p>
        <h1>Activity</h1>
        <p>Recent reviews, product-rule decisions, and GitHub Check results.</p>
      </header>
      {error ? <InlineAlert tone="alert">{error}</InlineAlert> : null}
      {!events && !error ? <p className="rr-sr">Loading activity</p> : null}
      {events && events.length === 0 ? <p className="rr-activity-empty">Review activity and product decisions will appear here.</p> : null}
      {events && events.length ? (
        <ol className="rr-activity">
          {events.map((event) => {
            const when = relativeMoment(event.at);
            const codebase = event.owner && event.name ? `${event.owner}/${event.name}` : "Workspace";
            return (
              <li key={event.id}>
                <div>
                  <Link to={event.href}>{event.title}</Link>
                  <p>{codebase}</p>
                </div>
                <span className="rr-status-pill">{event.status}</span>
                <time dateTime={event.at} title={when.absolute}>{when.label || when.sentence}</time>
              </li>
            );
          })}
        </ol>
      ) : null}
    </div>
  );
}
